module.exports = __webpack_public_path__ + "static/media/aero3.cb6276d4.jpg";